import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addPage } from "../store/state/pagehistory";

const Pagetracker = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(addPage({
            pathname: location.pathname,
            state: location.state
        }));
    }, [location.pathname, location.state, dispatch]);

    return null;
};

export default Pagetracker;